import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../../components/Base';
var styles = {
  "root": "ListRow-root_1hWLf"
};
function ListRow(_ref) {
  var children = _ref.children,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      flex: true,
      flexNoWrap: true,
      className: clsx(styles.root, className)
    }, extraProps), children)
  );
}
export default ListRow;